const STREET_TYPE_WORDS =
  /\b(street|st|avenue|ave|road|rd|drive|dr|lane|ln|court|ct|boulevard|blvd|place|pl|terrace|ter|way)\b/g;

/**
 * Normalizes an address down to just its street line (number + name),
 * dropping anything after the first comma (city/state/zip) and ignoring
 * case, punctuation and street-type wording people type inconsistently.
 */
export function normaliseAddress(v) {
  const streetOnly = String(v || "").split(",")[0];
  return streetOnly
    .toLowerCase()
    .replace(/[.,#]/g, " ")
    .replace(STREET_TYPE_WORDS, "")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Finds an existing property whose address matches `value`. Match is exact
 * (on the normalized street line), not a prefix in either direction - two
 * properties that merely share a house number (e.g. "123 Main St" and
 * "123 Oak Ave") must not collide.
 */
export function findExistingProperty(value, existingProperties) {
  const target = normaliseAddress(value);
  if (!target) return null;
  return (existingProperties || []).find((prop) => {
    const candidates = [prop?.Location, prop?.Street, prop?.address].filter(
      Boolean,
    );
    return candidates.some((c) => normaliseAddress(c) === target);
  });
}
